import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { EmptyPlaceholder } from '../../../../../../shared/components/EmptyPlaceholder'
import { Fade } from '@mui/material'
import React from 'react'
import { ValueMessageLinkedData } from '../../../../../../shared/queries/useGetValueMessageLinkedDataQuery'
import OngoingActivitiesExpandedRowItem from './components/OngoingActivitiesExpandedRowItem'
import { ValueMessage } from '../../../../../ValueNarrativesView/queries/useGetValueNarrativesQuery'
import useActivitiesDisplayName from '../../../../../../shared/hooks/useDisplayNames/variants/useActivitiesDisplayName'
import useOngoingDisplayName from '../../../../../../shared/hooks/useDisplayNames/variants/useOngoingDisplayName'

type SupportingEvidenceExpandedRowProps = {
    ongoingActivities: ValueMessageLinkedData['ongoingActivities']
    navigationStack: ArrayLike<object>
    valueMessage: ValueMessage
}

const OngoingActivitiesExpandedRow = ({
    ongoingActivities,
    navigationStack,
    valueMessage,
}: SupportingEvidenceExpandedRowProps) => {
    const activitiesDisplayName = useActivitiesDisplayName()
    const ongoingDisplayName = useOngoingDisplayName()

    return (
        <Fade in timeout={800}>
            <Stack
                direction="column"
                pl={9}
                pr={4}
                py={1.5}
                borderTop="1px solid"
                borderBottom="1px solid"
                borderColor="figma.grayscale.stroke"
            >
                <Typography variant="16x700" mb={0.5}>
                    {`${ongoingDisplayName.value} ${activitiesDisplayName.plural}`}
                </Typography>

                {!ongoingActivities?.length && (
                    <Stack direction="column" alignItems="flex-start">
                        <EmptyPlaceholder text="No data to display" />
                    </Stack>
                )}

                {ongoingActivities.map((activity, index) => {
                    return (
                        <Stack
                            key={activity._id}
                            direction="column"
                            gap={1}
                            py={1.5}
                            {...(index !== ongoingActivities.length - 1 && {
                                borderBottom: '1px solid',
                                borderColor: 'figma.grayscale.stroke',
                                px: 1.5,
                                mx: -1.5,
                            })}
                        >
                            <OngoingActivitiesExpandedRowItem
                                navigationStack={navigationStack}
                                activity={activity}
                                valueMessage={valueMessage}
                            />
                        </Stack>
                    )
                })}
            </Stack>
        </Fade>
    )
}

export default OngoingActivitiesExpandedRow
